module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};



//////////////////
// WEBPACK FOOTER
// C:/thinkbit/conference/hosting/~/core-js/modules/_an-instance.js
// module id = ../../../../core-js/modules/_an-instance.js
// module chunks = 18